import {Component, OnInit} from '@angular/core';
import {LanguageService} from '@services/language.service';
import {CycleService} from '@services/cycle.service';
import {Cycle} from '@services/model/cycle';
import moment from 'moment';
import {MaOverviewStatsResource} from '@services/resource/ma-overview-stats-resource';
import {StatsService} from '@services/stats.service';
import {ProductStatus} from '@services/model/product';
import {VoilaUserService} from '@services/voila-user.service';
import {RouterLink} from '@angular/router';
import {MatCard, MatCardContent, MatCardTitle} from '@angular/material/card';
import {MinPrivilegeDirective} from '@util/directives/min-privilege.directive';
import {CommonModule} from '@angular/common';
import {RouteBuilder} from '@util/route-builder';

@Component({
  selector: 'app-ma-dashboard',
  templateUrl: './ma-dashboard-welcome.component.html',
  styleUrls: ['./ma-dashboard-welcome.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, MatCard, MatCardTitle, MatCardContent, MinPrivilegeDirective],
})
export class MaDashboardWelcomeComponent implements OnInit {
  nextCycle?: Cycle;
  productStatusRequested: ProductStatus = ProductStatus.requested;
  stats?: MaOverviewStatsResource;

  constructor(
    private readonly languageService: LanguageService,
    private readonly cycleService: CycleService,
    private readonly statService: StatsService,
    readonly userService: VoilaUserService,
  ) {}

  ngOnInit() {
    this.languageService.initBrowserLanguage();
    this.cycleService.getAll(false).subscribe((cycles) => {
      /* find the nearest pitch date */
      cycles.sort((c1, c2) => c2.pitchDate.unix() - c1.pitchDate.unix());
      this.nextCycle = cycles[0];
    });

    this.statService.getMaOverviewStats().subscribe((r) => {
      this.stats = r;
    });
  }

  get daysUntilPitchDate(): number | null {
    if (!this.nextCycle) {
      return null;
    }

    const d = moment.duration(this.nextCycle.pitchDate.diff(moment(new Date())));
    return Math.round(d.asDays());
  }

  get routes() {
    return {
      products: RouteBuilder.app().maDashboard().products().build(),
      cycles: RouteBuilder.app().maDashboard().cycles().build(),
      mailjetExport: RouteBuilder.app().maDashboard().mailjetExport().build(),
      registrationDebugger: RouteBuilder.app().maDashboard().registrationDebugger().build(),
      users: RouteBuilder.app().maDashboard().users().build(),
    };
  }
}
